import Router from 'lib/Router';

import AccountView from 'view/user/account';
import CreateView from 'view/user/create';
import ManageView from 'view/user/manage';
import PasswordView from 'view/user/password';

import User from 'model/User';

export default Router.extend({
	routes: {
		'user/account': 'executeAccount',
		'user/register': 'executeCreate',
		'user/create': 'executeCreate',
		'user/manage': 'executeManage',
		'user/password': 'executePassword'
	},


	unsecure: [ 'executeCreate' ],

	// Visualisation de mon compte
	executeAccount: function()
	{
		var user = app.getStore('user');

		var view = new AccountView({
			model: user
		});

		app.render( view );
		app.history.push( Backbone.history.getHash() );

		if( app.is('online') && user.has('id') && !user.isSavable() )
		{
			user.fetch({ background: true });
		}
	},


	// Modification de mon compte
	executeManage: function()
	{
		var user = app.getStore('user');

		var view = new ManageView({
			model: user
		});

		app.render( view );
	},



	// Modification de mon compte
	executePassword: function()
	{
		var user = app.getStore('user');

		var view = new PasswordView({
			model: user
		});

		app.render( view );
	},


	// Création d'un compte
	executeCreate: function()
	{
		if( app.is('authenticated') )
		{
			return app.redirect('default/index');
		}

		var view = new CreateView({
			model: new User
		});

		app.render( view );
	},



	//*/
});
